import { useObserver } from "mobx-react";
import {
  AiOutlineCloseCircle,
} from "react-icons/ai";
import { useStores } from "../../../store";
import Input from "../../JobPost/input";
import Experience from "../../JobPost/experience";
import Select from "../../JobPost/Select";
import Skills from "../../JobPost/Skills";
import { useState } from "react";
import { BsStars } from "react-icons/bs";
import Loader from "../../reusble_components/loader";

export default function GeneratePopup(props) {
  const { PopupStore, RecuiterStore } = useStores();
  const [skills, setSkills] = useState([]);
  const closeThisPopUP = () => {
    PopupStore.setGenerate(false);
  };
  const setaddedSkills = (skill) => {
    if (!RecuiterStore.generateParams.skills.includes(skill) && skill !== "") {
      RecuiterStore.SetGenerateParams("skills", [
        ...RecuiterStore.generateParams.skills,
        skill,
      ]);
      setSkills([...skills, skill]);
    }
  };

  const handleAutoGeneration = async () => {
    const res = await RecuiterStore.autoGenerateJD();
    closeThisPopUP();
  };

  const removeaddedSkills = (index) => {
    RecuiterStore.SetGenerateParams(
      "skills",
      RecuiterStore.generateParams.skills.filter((_, i) => i !== index)
    );
    setSkills(skills.filter((_, i) => i !== index));
  };

  return useObserver(() => {
    return (
      <>
        {PopupStore.generate && (
          <div
            onClick={closeThisPopUP}
            className="fixed w-screen h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40 flex justify-center items-center px-4"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="relative bg-bg3 z-50 flex flex-col justify-center rounded-3xl border items-center w-full max-w-lg md:max-w-2xl lg:max-w-3xl h-auto md:h-[80%] lg:h-[50%] m-auto shadow-lg overflow-y-auto p-6 tc8:max-w-xl" 
            >
              <AiOutlineCloseCircle
                className="absolute text-xl text-primary cursor-pointer top-4 right-4"
                onClick={closeThisPopUP}
              />
              <div className="flex flex-col w-full justify-center items-center md:gap-6 lg:gap-6 gap-3">
                <p className="font-semibold text-lg text-primary text-center">
                  Add Basic details to auto generate
                </p>
                <button
                  className="text-primary opacity-50 hover:underline -my-4 self-end"
                  onClick={() => {
                    RecuiterStore.ClearGenerateParams();
                    RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills =
                      [];
                  }}
                >
                  Reset
                </button>
                <Loader loader={RecuiterStore.generaterLoader} />
                <form
                  className="flex flex-col w-full"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (RecuiterStore.generateParams.skills.length === 0) {
                      alert("Please add at least one skill");
                      return;
                    }
                    if (
                      Number(RecuiterStore.generateParams.minexp) >
                      Number(RecuiterStore.generateParams.maxexp)
                    ) {
                      alert(
                        "Minimum experience should be less than maximum experience"
                      );
                      return;
                    }
                    handleAutoGeneration();
                  }}
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 md:gap-4 lg:gap-4 gap-1">
                    <Input
                      label="Job title"
                      height="h-10"
                      type="text"
                      placeholder="Enter job title"
                      gen={true}
                      defaultValue={RecuiterStore.generateParams.title}
                      action={(e) => {
                        RecuiterStore.SetGenerateParams(
                          "title",
                          e.target.value
                        );
                      }}
                    />
                    <Experience
                      label="Required experience"
                      gen={true}
                      isResumeSorting={true}
                      value1={RecuiterStore.generateParams.minexp}
                      value2={RecuiterStore.generateParams.maxexp}
                      action1={(e) => {
                        RecuiterStore.SetGenerateParams(
                          "minexp",
                          e.target.value
                        );
                      }}
                      action2={(e) => {
                        RecuiterStore.SetGenerateParams(
                          "maxexp",
                          e.target.value
                        );
                      }}
                    />
                    <Select
                      label="Work mode"
                      required={true}
                      height="h-10"
                      value={RecuiterStore.generateParams.mode}
                      action={(e) => {
                        RecuiterStore.SetGenerateParams("mode", e.target.value);
                      }}
                      options={[
                        { label: "Work from Office", value: "workFromOffice" },
                        { label: "Work from Home", value: "workFromHome" },
                        { label: "Hybrid", value: "hybrid" },
                      ]}
                    />
                    <Input
                      label="Qualification"
                      height="h-10"
                      type="text"
                      placeholder="Qualification required"
                      gen={true}
                      defaultValue={RecuiterStore.generateParams.qualification}
                      action={(e) => {
                        RecuiterStore.SetGenerateParams(
                          "qualification",
                          e.target.value
                        );
                      }}
                    />
                  </div>

                  <Skills
                    Skills={["Adobe XD", "React JS", "Flutter"]}
                    setaddedSkills={setaddedSkills}
                    value={RecuiterStore.generateParams.skills}
                    addedSkills={skills}
                    removeSkills={removeaddedSkills}
                  />

                  <div className="w-full mt-4 flex justify-center items-center">
                    <button
                      className="p-2 w-36 tc8:-mt-3.5 rounded-xl bg-primary text-white font-semibold  flex justify-center items-center gap-2"
                      type="submit"
                    >
                      <BsStars /> Generate
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </>
    );
  });
}
